import React from 'react'
import './sustamizeSpinner.css'

import sustamizeLogo from './signet.png'

export const SustamizeSpinner: React.FC = () => {
  return (
    <div className="sustamize-spinner-wrapper">
      <img src={sustamizeLogo} alt="Sustamize" className="sustamize-logo" />
    </div>
  )
}
